/* --= Action Types =-- */

export enum SimilarByPatternActionTypes {
  GetSimilarByPatternSettingsRequest = 'SimilarByPattern/GetSimilarByPatternSettingsRequest',
  GetSimilarByPatternSettingsSuccess = 'SimilarByPattern/GetSimilarByPatternSettingsSuccessAction',
  GetSimilarByPatternSettingsError = 'SimilarByPattern/GetSimilarByPatternSettingsError',
  UpdateSimilarByPatternSettingsRequest = 'SimilarByPattern/UpdateSimilarByPatternSettingsRequest',
  UpdateSimilarByPatternSettingsSuccess = 'SimilarByPattern/UpdateSimilarByPatternSettingsSuccess',
  UpdateSimilarByPatternSettingsError = 'SimilarByPattern/UpdateSimilarByPatternSettingsError',
  NotifySimilarByPatternSettingsIsDirty = 'SimilarByPattern/NotifyIsDirty',
}
export interface UpdateSimilarByPatternSettingsPayload {
  shopId: number;
  numberOfResultsToDisplay: number;
}

export interface GetSimilarByPatternSettingsArgs {
  shopId: number;
}

export interface GetSimilarByPatternSettingsRequestPayload {
  shopId: number;
}

export interface GetSimilarByPatternSettingsSuccessPayload {
  shopId: number;
  numberOfResultsToDisplay: number;
}

export interface GetSimilarByPatternSettingsErrorPayload {
  error: unknown;
}
export interface UpdateSimilarByPatternSettingsRequestPayload {
  shopId: number;
  numberOfResultsToDisplay: number;
}

export interface UpdateSimilarByPatternSettingsSuccessPayload {
  shopId: number;
  numberOfResultsToDisplay: number;
}

export interface UpdateSimilarByPatternSettingsErrorPayload {
  error: unknown;
}

export interface NotifySimilarByPatternSettingsIsDirtyActionPayload {
  isDirty: boolean;
}

/* --= Action Interfaces =-- */

export interface GetSimilarByPatternSettingsRequestAction {
  type: typeof SimilarByPatternActionTypes.GetSimilarByPatternSettingsRequest;
  payload: GetSimilarByPatternSettingsRequestPayload;
}

export interface GetSimilarByPatternSettingsSuccessAction {
  type: typeof SimilarByPatternActionTypes.GetSimilarByPatternSettingsSuccess;
  payload: GetSimilarByPatternSettingsSuccessPayload;
}

export interface GetSimilarByPatternSettingsErrorAction {
  type: typeof SimilarByPatternActionTypes.GetSimilarByPatternSettingsError;
  payload: GetSimilarByPatternSettingsErrorPayload;
}

export interface UpdateSimilarByPatternSettingsRequestAction {
  type: typeof SimilarByPatternActionTypes.UpdateSimilarByPatternSettingsRequest;
  payload: UpdateSimilarByPatternSettingsRequestPayload;
}

export interface UpdateSimilarByPatternSettingsSuccessAction {
  type: typeof SimilarByPatternActionTypes.UpdateSimilarByPatternSettingsSuccess;
  payload: UpdateSimilarByPatternSettingsSuccessPayload;
}

export interface UpdateSimilarByPatternSettingsErrorAction {
  type: typeof SimilarByPatternActionTypes.UpdateSimilarByPatternSettingsError;
  payload: UpdateSimilarByPatternSettingsErrorPayload;
}

export interface NotifySimilarByPatternSettingsIsDirtyAction {
  type: typeof SimilarByPatternActionTypes.NotifySimilarByPatternSettingsIsDirty;
  payload: NotifySimilarByPatternSettingsIsDirtyActionPayload;
}

export type SimilarByPatternSettingsAction =
  | GetSimilarByPatternSettingsRequestAction
  | GetSimilarByPatternSettingsSuccessAction
  | GetSimilarByPatternSettingsErrorAction
  | UpdateSimilarByPatternSettingsRequestAction
  | UpdateSimilarByPatternSettingsSuccessAction
  | UpdateSimilarByPatternSettingsErrorAction
  | NotifySimilarByPatternSettingsIsDirtyAction;
